import { useCallback, useContext } from 'react';
import { usePaymentContext } from '../PaymentProvider';
import { ModalsContext } from 'contexts/modals';
import { useFlittWallets } from 'libs/hooks/flitt';

const Wallets = () => {
  const { callResponse } = useContext(ModalsContext);
  const { fetchToken, merchantId, totalAmount, onSuccess: handleSuccess, walletToken } = usePaymentContext();

  const onSuccess = useCallback(() => {
    handleSuccess();
  }, [handleSuccess]);

  const onError = useCallback(() => {
    callResponse({ statusCode: false });
  }, [callResponse]);

  useFlittWallets({
    methods: ['apple'],
    element: '.flitt_payment_container_apple',
    amount: totalAmount,
    merchantId,
    onSuccess,
    onError,
    params: {
      token: walletToken
    }
    // handleToken: fetchToken,
  });

  return (
    <div className='max-width-md-150px' style={{ width: '100%' }}>
      <div className="flitt_payment_container_apple"></div>
    </div>
  );
};

export default Wallets;
